import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { Route, Routes } from 'react-router-dom'
import { clear_short_error_action } from "../actions/error_actions"
import { Error404 } from "../components/application_components/error_boundary/Error404"

import { AboutUs } from "../components/application_components/public_landing_page/about."
import { ContactUs } from "../components/application_components/public_landing_page/contact_us"
import { Home, HomeVersion2 } from "../components/application_components/public_landing_page/home_window"
import { Packages } from "../components/application_components/public_landing_page/packages"
import { faqs } from "../components/application_components/public_landing_page/packages_faqs_mock"
import { ErrorSuccessBar } from "../components/sharable_components/small_components/alerts/fail_success_bars"
import {LoadingSpinner} from "../components/sharable_components/small_components/alerts/loading"
import { Footer } from "../components/specific_components/footer/Footer"
import { Faqs } from "../components/specific_components/packages_components.js/packages_faqs"
import { PublicHeader } from "../components/specific_components/public_header/public_header"
// import { SideBar } from "../components/specific_components/public_header/side_nav_bar"
import { about_info } from "../settings/about_info"

import './main.css'
import { CompanyPolicies } from "../components/application_components/public_landing_page/policies_page"
import { RoutingV2 } from "../components/application_components/public_landing_page/landing_v2/App"

// function useScrollDirection(){
//     const [scrollDirection, setScrollDirection] = useState(null)

//     useEffect(()=>{
//         let lastScrollY = window.scrollY

//         const updateScrollDirection = () => {
//             const scrollY = window.scrollY
//             const direction = scrollY > lastScrollY ? "down":"up"
//             if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
//                 setScrollDirection(direction)
//             }lastScrollY = scrollY > 0 ? scrollY : 0
//         }
//         window.addEventListener("scroll", updateScrollDirection)
//         return () => {
//             window.removeEventListener("scroll", updateScrollDirection)
//         }
//     }, [scrollDirection])
//     return scrollDirection
// }

export const Router = () =>{
    const [opensidebar, setOpensidebar] = useState(false)

    window.addEventListener('click', function(e){   
        if (document.getElementById('side_bar_button')?.contains(e.target)){
          // Clicked in box
          if(!opensidebar){
            setOpensidebar(false)
          } else{
              setOpensidebar(true)
          }
        } else{
            // setOpensidebar(false)
        }
      });
      window.addEventListener('scroll', function(e){   
        if (e.target.contains(document.getElementById('extra_nav_bar'))){
            // scroll the box
            setOpensidebar(true)
          } else{
              setOpensidebar(false)
          }
  });
    const dispatch = useDispatch()
    const loading = useSelector(state=>state.loading_state)

    const short_alert = useSelector(state => state.short_alert)
    if(short_alert){
        setTimeout(() => {
            dispatch(clear_short_error_action())
        }, 3000);
    }


    return (
        <div>
            <div className="main_component display_row_grids">
                <div className="flex_grid_main main_content_container">
                    <div className="all_objects_stretch">
                        <div className={`top_bar`} id="top_nav_bar">
                            <PublicHeader 
                                setOpensidebar={setOpensidebar} 
                                opensidebar={opensidebar} 
                            />
                        </div>
                        <div className="top_bar">
                            {/* alert messages */}
                            {short_alert && <ErrorSuccessBar message={short_alert.message} alert_type={short_alert.alert_type}/>}
                            {/* Loading spinner */}
                            {loading.loading_state && <LoadingSpinner message={loading.message} />}
                         </div>
                        <div className="" id="body_no_nav_bar">
                            <div className="components_stretch">

                                <Routes>
                                    <Route path="home" element={<Home />} />
                                    <Route path='packages/*' element={<Packages/>} />
                                    <Route path='about' element={<AboutUs about_info={about_info} />} />
                                    <Route path='contact_us' element={<ContactUs />} />
                                    <Route path="faqs" element={<Faqs qsns={faqs}/>} />
                                    <Route path="policies/*" element={<CompanyPolicies />} />
                                    <Route path='*' element={<Error404 />} />
                                </Routes>
                             </div>
                        </div>
                    </div>
                    <div className="footer_sticky">
                        <Footer />  

                    </div>
                </div>
            </div>
        </div>
    )
}
